<section class="has-padding-block-6 animated fadeIn" >
  <div class="row">
    <div class="col-md-7">
      <h2 class="section-title">Low Cost Produce Program</h2>
      <p>Our Low-Cost Produce Box (LCPB) program helps community groups, organizations, and buying clubs increase access to high-quality local fruits and vegetables at lower prices by buying in bulk.</p>
    </div>
    <div class="col-md-5">
      <img src="../../../assets/images/landing/low-cost-produce/low-cost-produce-program.webp" class="img-side is-height-3" alt="Low Cost Produce Program - image">
    </div>
  </div>
  <hr class="is-thick">
  <div>
    <h2 class="section-title">How it works</h2>
    <div class="num-step-wrap">
      <div class="num-step" *ngFor="let step of lowCostSteps">
        <span class="num">{{step.num}}</span>
        <div class="detail">
          <div class="text">{{step.title}}</div>
          <span class="arrow material-symbols-outlined" *ngIf="step.arrow; else arrowBlank">east</span>
          <ng-template #arrowBlank>
            <span class="arrow"></span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <hr class="is-thick">
  <div class="banner-title-wrap is-center">
    <div class="banner-title is-inline is-primary">We believe in good food for all.</div>
  </div>
  <div class="mt-5">
    <h2 class="section-title">Pricing and other specifics</h2>
    <p>Our standard produce box costs $20 (usually retails at $27) and includes 6 to 8 varieties of fruit and vegetables. The produce included is intended to meet the needs of 2 to 3 people.</p>
    <p>You can include the following add-ons in your boxes:</p>
    <ul class="ul-checklist ul-checklist--circle">
      <li>Fruit boost — $10 (normally $13); additional fruit</li>
      <li>Bread share — $7 (normally $9); a loaf of fresh-baked bread</li>
      <li>Eggs — $4.50 (normally $6); a dozen pasture-raised eggs</li>
      <li>Yogurt — $5.75 (normally $7.75); a quart of locally-made yogurt</li>
    </ul>
    <p>You will have the opportunity to set the parameters for the boxes for your customers. For instance, are there items you would never like us to include? How much fruit do you want? Any items you would like every week?</p>
  </div>
  <hr class="is-thick">
  <div>
    <h2 class="section-title">More ways we help increase food access</h2>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">handshake</span>
      <div class="list-content">
        <p>Grant research. Need help subsidizing the cost of the produce boxes? We’ll send you grant opportunities that make sense for your organization.</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">shoppingmode</span>
      <div class="list-content">
        <p>Lower introductory pricing. To entice your growing cohort of customers, we offer reduced prices for the first few orders.</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">orders</span>
      <div class="list-content">
        <p>Order minimum flexibility. It's OK to start small. We aim to have a minimum of 50 boxes/delivery; however, if you’re having trouble finding 50 customers to start with, we’re happy to work something out while you build interest.</p>
      </div>
    </div>
    <p>Want to learn more? Fill out <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLScFvF6xOvc7PkQmsOn1Dcr-bhT3YIShAle6o9oauPcZssDLYw/viewform">this form</a> or contact us at info&#64;phillyfoodworks.com to chat about the program and how you can get started.</p>
  </div>
</section>
